module.exports = __webpack_public_path__ + "img/video-bg.9b09572f.jpg";